module.exports = __webpack_public_path__ + "cx.9002f4a7934076420bdd.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/cx.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/cx.svg
// module chunks = styles